<div class="modal-header">
  <h2 class="modal-title">{{ "invoice.filterPopup.title" | translate }}</h2>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeHandler()"
  >
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12 l-title-txt">
      {{ "invoice.filterPopup.billingPeriod" | translate }}
    </div>
    <div class="col-md-6 select-date">
      <label class="label-input">
        {{ "invoice.filterPopup.fromDate" | translate }}
      </label>
      <kendo-datepicker HJSuppress
        class="custom-kendo-control-xl"
        [fillMode]="fillModeOutline"
        [rounded]="roundedLarge"
        [(ngModel)]="startDate"
        [disabledDates]="disableStartDates"
        #startDateInput
        (click)="!startDateInput.isOpen ? startDateInput.toggle() : null"
        [popupSettings]="{popupClass : 'data-hj-suppress'}"
      >
        <kendo-datepicker-messages
          today="{{ 'calendar.today' | translate }}"
          toggle="{{ 'calendar.toggle' | translate }}"
        >
        </kendo-datepicker-messages>
      </kendo-datepicker>
    </div>
    <div class="col-md-6 select-date">
      <label class="label-input">
        {{ "invoice.filterPopup.toDate" | translate }}
      </label>
      <kendo-datepicker HJSuppress
        class="custom-kendo-control-xl"
        [fillMode]="fillModeOutline"
        [rounded]="roundedLarge"
        [(ngModel)]="endDate"
        [disabledDates]="disableEndDates"
        #endDateInput
        (click)="!endDateInput.isOpen ? endDateInput.toggle() : null"
        [popupSettings]="{popupClass : 'data-hj-suppress'}"
      >
        <kendo-datepicker-messages
          today="{{ 'calendar.today' | translate }}"
          toggle="{{ 'calendar.toggle' | translate }}"
        >
        </kendo-datepicker-messages>
      </kendo-datepicker>
    </div>
  </div>

  <div class="l-separator"></div>

  <div class="row modal-section">
    <div class="col-md-12 l-title-txt">
      {{ "invoice.filterPopup.category" | translate }}
    </div>
    <div
      *ngFor="let category of categories"
      class="col-md-6 d-flex align-items-center mb-3"
    >
      <input 
        type="checkbox" 
        kendoCheckBox
        [size]="size"
        [rounded]="roundedLarge"
        [id]="category.id"
        [(ngModel)]="category.isSelected"

      />
      <label HJSuppress
        [for]="category.id" 
        class="cursor-pointer ms-2">
        {{ category.type }}
      </label>
    </div>

    <div class="col-md-6 d-flex align-items-center mb-3">
      <input
        type="checkbox" 
        kendoCheckBox
        [size]="size"
        [rounded]="roundedLarge"
        [id]="'other-category'"
        [(ngModel)]="isOtherCategory"
      />
      <label HJSuppress
        [for]="'other-category'" 
        class="cursor-pointer ms-2">
        {{ "invoice.filterPopup.other" | translate}}
      </label>
    </div>
  </div>

  <div class="l-separator"></div>

  <div class="row modal-section">
    <div class="col-md-12 l-title-txt">
      {{ "invoice.filterPopup.status" | translate }}
    </div>
    <div *ngFor="let status of statuses; index as i"
        class="col-md-6 d-flex align-items-center mb-3">
        <input 
            type="checkbox" 
            kendoCheckBox 
            [(ngModel)]="status.isSelected" 
            [id]="status.name+i" 
            [size]="size"
            [rounded]="roundedLarge"/>
        <label HJSuppress [for]="status.name+i" class="cursor-pointer ms-2">
            {{ status.name }}
        </label>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn link-btn" (click)="resetHandler()">
    <i class="app-icon icon icon-reload icon-lg me-2"></i> 
    {{ "invoice.filterPopup.reset" | translate }}
  </button>
  <button class="btn primary-btn" (click)="applyHandler()">
    {{ "invoice.filterPopup.apply" | translate }}
  </button>
</div>
